import React, { useMemo } from 'react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import useToggle from '../../../../hooks/useToggle';
import { colors } from '../../../../constants/colors';
import { fontFamily, fontSize } from '../../../../constants/text';
import { getUserAgent } from '../../../../core/util/device';

const Root = styled.div.withConfig({ componentId: 'sc-17gqzit-0' })`
  margin-top: 10px;
  text-align: center;
`;

const DialogRoot = styled.div.withConfig({ componentId: 'sc-17gqzit-1' })`
  padding: 12px;
  text-align: center;
`;

const InfoGrid = styled.div.withConfig({ componentId: 'sc-17gqzit-2' })`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: min-content;
  row-gap: 2px;
`;

const InfoKey = styled.div.withConfig({ componentId: 'sc-17gqzit-3' })`
  color: ${colors.lightText};
  font-family: ${fontFamily.medium};
  font-size: ${fontSize.mediumSmall};
  text-align: left;
  border-bottom: 1px solid ${colors.borderLine};
  padding-right: 4px;
`;

const InfoValue = styled(InfoKey).withConfig({ componentId: 'sc-17gqzit-4' })`
  color ${colors.squid};
  font-family: ${fontFamily.book};
  text-align: right;
  padding-right: 0;
  padding-left: 4px;
`;

const CloseLink = styled.div.withConfig({ componentId: 'sc-17gqzit-5' })`
  margin-top: 40px;
  color: ${colors.blueJayWay};
  text-align: center;
  font-size: ${fontSize.default};
  font-family: ${fontFamily.medium};
  text-transform: uppercase;
  cursor: pointer;
`;

const AppInfo = () => {
  const [open, toggleOpen] = useToggle();
  const userAgent = getUserAgent();
  const info = useMemo(() => {
    return userAgent
      .split('-')
      .filter((v) => v.split(':').length > 1)
      .map((i) => [i.split(':')[0], i.split(':')[1]]);
  }, [userAgent]);

  return (
    <Root>
      <Dialog onClose={toggleOpen} open={open}>
        <DialogRoot>
          <InfoGrid>
            {info.map(([key, value]) => (
              <React.Fragment key={key}>
                <InfoKey>{key}</InfoKey>
                <InfoValue>{value}</InfoValue>
              </React.Fragment>
            ))}
          </InfoGrid>
          <CloseLink onClick={toggleOpen}>Close</CloseLink>
        </DialogRoot>
      </Dialog>
      <a onClick={toggleOpen}>App Info</a>
    </Root>
  );
};

export default AppInfo;
